import { CodeHighlightNode, CodeNode } from '@lexical/code';
import { HashtagNode } from '@lexical/hashtag';
import { AutoLinkNode, LinkNode } from '@lexical/link';
import { ListItemNode, ListNode } from '@lexical/list';
import { MarkNode } from '@lexical/mark';
import { OverflowNode } from '@lexical/overflow';
import { HorizontalRuleNode } from '@lexical/react/LexicalHorizontalRuleNode';
import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { TableCellNode, TableNode, TableRowNode } from '@lexical/table';

import { ImageNode } from './ImageNode';
import { PageBreakNode } from './PageBreakNode';
import { EmojiNode } from './EmojiNode';
import { CollapsibleContainerNode } from './CollapsibleContainerNode';
import { CollapsibleContentNode } from './CollapsibleContentNode';
import { CollapsibleTitleNode } from './CollapsibleTitleNode';
import { LayoutContainerNode } from './LayoutContainerNode';
import { LayoutItemNode } from './LayoutItemNode';
import { EquationNode } from './EquationNode';
import { PollNode } from './PollNode';
import { ExcalidrawNode } from './ExcalidrawNode';
import { SectionAnchorNode } from './SectionAnchorNode';

const PlaygroundNodes = [
  HeadingNode,
  ListNode,
  ListItemNode,
  QuoteNode,
  CodeNode,
  CodeHighlightNode,
  TableNode,
  TableCellNode,
  TableRowNode,
  HashtagNode,
  AutoLinkNode,
  LinkNode,
  OverflowNode,
  ImageNode,
  HorizontalRuleNode,
  MarkNode,
  PageBreakNode,
  EmojiNode,
  CollapsibleContainerNode,
  CollapsibleContentNode,
  CollapsibleTitleNode,
  LayoutContainerNode,
  LayoutItemNode,
  EquationNode,
  PollNode,
  ExcalidrawNode,
  SectionAnchorNode,
];

export default PlaygroundNodes;
